<template>
    <div class="lang">
        <div class="popup4" :class="{ active: popupShow }">
            <div class="popup__inner">
                <div class="popup__certification">
                    <div class="popup__tit">
                        <h2>Endoscope room on the 4th floor</h2>
                        <button type="button" class="popup__close" @click="popupBtn"><img src="/resource/icon/close.svg" alt=""></button>
                    </div>
                    <div class="popup__body">
                        <div class="subSwiper info">
                            <swiper ref="mySwiper" :navigation="{
                                nextEl: '.subSwiper-next',
                                prevEl: '.subSwiper-prev'
                              }" :pagination="{ clickable: true }" :grabCursor="true" :effect="'creative'" :creativeEffect="{
                                prev: {
                                    shadow: true,
                                    translate: ['-20%', 0, -1],
                                },
                                next: {
                                    translate: ['100%', 0, 0],
                                },
                                }" :speed="700" :modules="modules" @swiper="onSwiperInit">
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery01.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery02.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery03.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery04.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery05.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery06.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery07.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide>
                                    <img src="/resource/img/img_view_gallery08.jpg" alt="">
                                </swiper-slide>
                            </swiper>
                            <div class="subSwiper-bth subSwiper-next"></div>
                            <div class="subSwiper-bth subSwiper-prev"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="img-slide">
            <div class="img-slide__box img-slide__box1">
                <div class="left">
                    <button type="button" class="btn" @click="slideFn(1)">
                        <p class="hover">Lobby of the 4th floor</p>
                        <img src="/resource/img/img_view_gallery01.jpg" alt="">
                    </button>
                </div>
                <div class="right">
                    <button type="button" class="btn" @click="slideFn(2)">
                        <p class="hover">Lobby of the 3rd floor</p>
                        <img src="/resource/img/img_view_gallery02.jpg" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(3)">
                        <p class="hover">Lobby corridor on the 3rd floor</p>
                        <img src="/resource/img/img_view_gallery03.jpg" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(4)">
                        <p class="hover">Lobby corridor on the 4rd floor</p>
                        <img src="/resource/img/img_view_gallery04.jpg" style="object-position: 30%;" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(5)">
                        <p class="hover">Customer elevator</p>
                        <img src="/resource/img/img_view_gallery05.jpg" alt="">
                    </button>
                </div>
            </div>
            <div class="img-slide__box img-slide__box2">
                <div class="left">
                    <button type="button" class="btn" @click="slideFn(6)">
                        <p class="hover">Endoscope room on the 4th floor</p>
                        <img src="/resource/img/img_view_gallery06.jpg" alt="">
                    </button>
                    <button type="button" class="btn" @click="slideFn(7)">
                        <p class="hover">Mammography room on the 4th floor</p>
                        <img src="/resource/img/img_view_gallery07.jpg" alt="">
                    </button>
                </div>
                <div class="right">
                    <button type="button" class="btn" @click="slideFn(8)">
                        <p class="hover">CT room on the 4th floor</p>
                        <img src="/resource/img/img_view_gallery08.jpg" alt="">
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
    import { EffectCreative } from 'swiper/modules';
    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard, EffectCreative],
            };
        },
        data() {
            return {
                slideNum: '',
                popupShow: false,
                swiperInstance: null
            }
        },
        mounted() {
        },
        methods: {
            onSwiperInit(swiper) {
                this.swiperInstance = swiper;
            },
            slideFn(num) {
                this.slideNum = num
                if (window.innerWidth >= 720) {
                    this.popupShow = true
                }

                if (this.swiperInstance) {
                    this.swiperInstance.slideTo(num - 1);
                }
            },
            popupBtn() {
                if (window.innerWidth >= 720) {
                    this.popupShow = !this.popupShow;
                }
            }
        },
    }

</script>